export default {
    "created": "Produsul a fost creat cu succes",
    "updated": "Produsul a fost actualizat cu succes",
    "deleted": "Produsul a fost șters cu succes",
    "restored": "Produsul a fost restaurat cu succes",
}
